import writeXlsxFile from "write-excel-file";
import { listGameItemsCompleted } from "../../../utils/services/gameRd";
// moment
import moment from "moment";

export async function createXlsx({
  idEvent,
  nameEvent,
  limit,
  countData,
  setFinishExport,
}) {
  const schema = [
    {
      column: "IDEvento",
      type: String,
      value: (participant) => idEvent,
    },
    {
      column: "NomeEvento",
      type: String,
      value: (participant) => nameEvent,
    },
    {
      column: "IDParticipante",
      type: String,
      value: (participant) => participant.participantId,
    },
    {
      column: "NomeParticipante",
      type: String,
      value: (participant) => participant.participantName,
    },
    {
      column: "EmailParticipante",
      type: String,
      value: (participant) => participant.participantEmail,
    },
    {
      column: "Conteúdo",
      type: String,
      value: (participant) => participant.content,
    },
    {
      column: "RespostasCertas",
      type: Number,
      value: (participant) => Number(participant.correctAnswers),
    },
    {
      column: "TotalRespostas",
      type: Number,
      value: (participant) => Number(participant.totalAnswers),
    },
    {
      column: "DataHora",
      type: String,
      value: (participant) =>
        moment(participant.dateTime).format("DD/MM/YYYY H:mm:ss"),
    },
  ];

  const allRequestsPromises = [];
  const numberOfRequisitions = Math.ceil(countData / limit);

  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const request = await listGameItemsCompleted({
      idEvent: idEvent,
      offset: 1,
      limit: limit,
      search: "",
      columnSearch: "name",
    });
    allRequestsPromises.push(request);
    setTimeout(() => {}, 500);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");

    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(0)}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }

  const allDataInSingleArray = allRequestsPromises.map((e) => e.data).flat();
  if (allDataInSingleArray) {
    await writeXlsxFile(allDataInSingleArray, {
      schema,
      fileName: "GameRDPreWork.xlsx",
    });
  }
}
